import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata
} from '../../client-server-common';


export namespace DoppeActionTypeSendEmail {

    export interface ActionSettings {
        email: string;
    }
}

export const doppeActionTypeSendEmail = doppeActionTypeDefineMetadata<DoppeActionTypeSendEmail.ActionSettings>({
    id: 'io.bymo.action/send-email',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        email: '',
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            email: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false,
    hasNoLockInnerCTA: true,
})